import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestQueryGet = {
  path: "/:name/query",
  method: RouteHttpVerb.GET,
  namespace: "search-engine-post-type/v1"
};